/**
 * Severity presentation for system alerts, shared by the sidebar popup and the
 * System Alerts page so both render a given severity identically.
 */
export type SystemAlertSeverity = 'info' | 'warning' | 'error' | string;

export function systemAlertClasses(status: SystemAlertSeverity): string {
  switch (status) {
    case 'warning':
      return 'bg-amber-50 border-amber-400 text-amber-900';
    case 'error':
      return 'bg-red-50 border-red-400 text-red-900';
    default:
      return 'bg-blue-50 border-blue-400 text-blue-900';
  }
}

export function systemAlertAcknowledgeClasses(status: SystemAlertSeverity): string {
  switch (status) {
    case 'warning':
      return 'border-amber-500 hover:bg-amber-100';
    case 'error':
      return 'border-red-500 hover:bg-red-100';
    default:
      return 'border-blue-500 hover:bg-blue-100';
  }
}

export function systemAlertIconPath(status: SystemAlertSeverity): string {
  switch (status) {
    case 'warning':
      return '/icons/warning-triangle-outline.svg';
    case 'error':
      return '/icons/bi-solid-error.svg';
    default:
      return '/icons/info-empty.svg';
  }
}

/**
 * Severity as a DaisyUI semantic token, for surfaces that must follow the
 * active theme. The palette-based helpers above are fixed light colors, which
 * suit the floating popup but read as light boxes on a dark page.
 */
export function systemAlertMarkerClasses(status: SystemAlertSeverity): string {
  switch (status) {
    case 'warning':
      return 'text-warning';
    case 'error':
      return 'text-error';
    default:
      return 'text-info';
  }
}
